import {SearchType} from '../rules/constants';
import {NON_SORTABLE_SEARCH_TYPES} from '../constants';

/**
 * Check if search type is sortable (on the server)
 * @param searchType
 * @returns Search tupe is sortable
 */
export const isSearchTypeSortable = (searchType: SearchType) =>
	!(NON_SORTABLE_SEARCH_TYPES as number[]).includes(searchType);

export default isSearchTypeSortable;
